var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-with-tabs',{ref:"userModal",attrs:{"formKey":_vm.formKey,"formAction":_vm.formAction,"user":_vm.user,"users":_vm.users,"roles":_vm.roles},on:{"success":_vm.onSubmitSuccess}})
}
var staticRenderFns = []

export { render, staticRenderFns }